import "./App.css";
import { Main } from "./layouts";

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
